module.exports = __webpack_public_path__ + "img/robot.9e0973c0.png";